module.exports = __webpack_public_path__ + "img/logo.f88682a9.png";